/* eslint-disable no-restricted-globals */

'use strict';

var formValidation = require('base/components/formValidation');
var createErrorNotification = require('base/components/errorNotification');
var checkCaptcha = require('../thirdParty/recaptcha/reCaptcha');

/**
 * Submit registration ajax call
 * @param {JQuery} $form - current form
 * @param {Object} event - current event
 */
function registrationAjaxCall($form, event) {
    var url = $form.attr('action');

    $('form.registration').trigger('login:register', event);

    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: $form.serialize(),
        success: function (data) {
            $form.spinner().stop();
            if (!data.success) {
                $('form.registration').trigger('login:register:error', data);
                formValidation($form, data);
            } else {
                $('form.registration').trigger('login:register:success', data);
                location.href = data.redirectUrl;
            }
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
            }

            $form.spinner().stop();
        }
    });
}

/**
 * Submit login ajax call
 * @param {JQuery} $form - current form
 * @param {Object} event - current event
 */
function loginAjaxCall($form, event) {
    var url = $form.attr('action');

    $('form.login').trigger('login:submit', event);

    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: $form.serialize(),
        success: function (data) {
            $form.spinner().stop();
            if (!data.success) {
                formValidation($form, data);
                $('form.login').trigger('login:error', data);
            } else {
                $('form.login').trigger('login:success', data);
                location.href = data.redirectUrl;
            }
        },
        error: function (data) {
            if (data.responseJSON.redirectUrl) {
                window.location.href = data.responseJSON.redirectUrl;
            } else {
                $('form.login').trigger('login:error', data);
                $form.spinner().stop();
            }
        }
    });
}

module.exports = {
    login: function () {
        $('form.login').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            form.spinner().start();

            checkCaptcha(form, e, loginAjaxCall);
        });
    },

    register: function () {
        $('form.registration').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            form.spinner().start();

            checkCaptcha(form, e, registrationAjaxCall);
        });
    },

    resetPassword: function () {
        $('.reset-password-form').submit(function (e) {
            var $form = $(this);
            e.preventDefault();
            $form.spinner().start();

            var url = $form.attr('action');

            $('.reset-password-form').trigger('login:register', event);

            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    $form.spinner().stop();
                    if (!data.success) {
                        formValidation($form, data);
                    } else {
                        $('.request-password-title').text(data.receivedMsgHeading);
                        $('.request-password-body').empty()
                            .append('<p>' + data.receivedMsgBody + '</p>');
                        if (!data.mobile) {
                            $('#submitEmailButton').text(data.buttonText)
                                .attr('data-dismiss', 'modal');
                        } else {
                            $('.send-email-btn').empty()
                                .html('<a href="'
                                    + data.returnUrl
                                    + '" class="btn btn-primary btn-block">'
                                    + data.buttonText + '</a>');
                        }
                    }
                },
                error: function () {
                    $form.spinner().stop();
                }
            });
        });
    },

    trackOrder: function () {
        $('form.js-trackorder').on('submit', function (e) {
            var $form = $(this);

            if ($form.data('sitekey')) {
                e.preventDefault();
                checkCaptcha($form, e);
            }
        });
    },

    clearResetForm: function () {
        $('#login .modal').on('hidden.bs.modal', function () {
            $('#reset-password-email').val('');
            $('.modal-dialog .form-control.is-invalid').removeClass('is-invalid');
        });
    },

    forgotPassword: function () {
        $('#password-reset').on('click', function (e) {
            e.preventDefault();
        });
    }
};
